import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EmailViewer from "./index";

const EmailViewerDialog = ({ open, email, onClose, title = "Email" }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
    <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 700 }}>
        {title}
      </Typography>
      <IconButton onClick={onClose} size="small" aria-label="Close email viewer">
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers sx={{ bgcolor: "#f4f7fb" }}>
      {email ? <EmailViewer {...email} /> : null}
    </DialogContent>
  </Dialog>
);

export default EmailViewerDialog;
